import type { TradeHistoryFilters, TradeStatsFilters } from "./types";

// §4.5 — feature owns its query keys. Centralised here so cache invalidation
// from mutations and SSE subscribers writes to the same buckets.

export const tradeKeys = {
  all: ["trade"] as const,
  active: () => [...tradeKeys.all, "active"] as const,
  histories: () => [...tradeKeys.all, "history"] as const,
  history: (limit: number, offset: number, filters: TradeHistoryFilters = {}) =>
    [...tradeKeys.all, "history", limit, offset, filters] as const,
  statsRoot: () => [...tradeKeys.all, "stats"] as const,
  dailyStats: (from: string) =>
    [...tradeKeys.statsRoot(), "daily", from] as const,
  stats: (filters: TradeStatsFilters = {}) =>
    [...tradeKeys.statsRoot(), filters] as const,
  candles: (
    symbol: string,
    interval: number,
    countback: number,
    realtime = false,
  ) =>
    [
      ...tradeKeys.all,
      "candles",
      symbol,
      interval,
      countback,
      realtime,
    ] as const,
} as const;
